<template>
  <div class="grid">
    <v-progress-linear color="warning" indeterminate rounded height="3"
      v-if="isLoading || disableSaveBtn"></v-progress-linear>
    <v-form ref="form" lazy-validation v-on:submit.prevent v-if="editedItem && !isLoading">
      <div class="grid-title">
        <h4>
          {{
            $t(
              isAddNew
                ? "_ACTIVITY.RATE_CATEGORY_CREATE"
                : "_ACTIVITY.RATE_CATEGORY_UPDATE"
            )
          }}
        </h4>
      </div>
      <div class="grid-body p-3 border-top-unset mb-4">
        <v-row>
          <v-col sm="12" class="pb-0">
            <v-tabs v-model="tab" class="pl-0">
              <v-tab>{{ $t("DEFAULT") }}</v-tab>
              <v-tab v-for="name in languages" :key="name">{{ name }}</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-row>
                  <v-col sm="12" class="pb-0">
                    <label>{{ $t("_CATEGORY.NAME") }} *</label>
                    <v-text-field v-model="editedItem.nameVi" counter maxlength="250" class="input-counter"
                      :rules="ruleName" outlined dense v-on:keyup="updateRoomTitle(editedItem.nameVi)">
                    </v-text-field>
                  </v-col>
                  <v-col sm="12" class="pb-0">
                    <label>{{ $t("_CATEGORY.DESCRIPTION") }}</label>
                    <v-textarea :rows="3" :rules="ruleDescNotRequired" counter="3000" maxlength="3000"
                      class="input-counter" v-model="editedItem.descriptionVi" dense outlined
                      v-on:keyup="updateRoomDescription(editedItem.descriptionVi)">
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item v-for="code in codeLangs" :key="code">
                <v-row>
                  <v-col sm="12" class="pb-0">
                    <label>{{ $t("_CATEGORY.NAME") }} *</label>
                    <v-text-field v-model="editedItem.i18ns.find((x) => x.lang == code).name" counter maxlength="250"
                      class="input-counter" :rules="ruleName" outlined dense>
                    </v-text-field>
                  </v-col>
                  <v-col sm="12" class="pb-0">
                    <label>{{ $t("_CATEGORY.DESCRIPTION") }}</label>
                    <v-textarea :rows="3" :rules="ruleDescNotRequired" counter="3000" maxlength="3000"
                      class="input-counter" v-model="editedItem.i18ns.find((x) => x.lang == code).description" dense
                      outlined>
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
          <v-col sm="3" class="py-0">
            <label>{{ $t("_CATEGORY.CODE") }} *</label>
            <v-text-field v-model="editedItem.rateCategoryCode" :disabled="!isAddNew" :rules="ruleCode" outlined counter
              maxlength="20" class="input-counter code" dense>
            </v-text-field>
            <p class="mb-0 mt-2" v-if="editedItem.chainCode">
              {{ $t("CHAIN_CODE") }}: {{ editedItem.chainCode }}
            </p>
          </v-col>
          <v-col sm="3" class="py-0">
            <p class="mb-1">{{ $t("EQUIVALENT_TO_ROOM_NIGHT") }} *</p>
            <vue-numeric class="v-input--dense v-text-field--outlined w-100 px-2" style="line-height: 20px; height: 37px; border-color: #b3b3b3;"
                            :class="editedItem.convertedNight  ? '' : 'border-danger'" currency="%" currency-symbol-position="suffix"
                            v-model="editedItem.convertedNight " :min="1" :max="100" :precision="0"></vue-numeric>
          </v-col>
        </v-row>
        <v-divider />
        <label class="label-title">{{ $t("ASSIGN_RATE_TO_CATEGORY") }}</label>
        <v-row>
          <v-col sm="3">
            <v-card style="min-height: 350px">
              <v-card-title class="fs-14">{{ $t("UNASSIGN") }}</v-card-title>
              <div class="pl-2 pr-2">
                <v-text-field prepend-inner-icon="mdi-magnify" :placeholder="$t('NAME_SELLING_PACKAGE')"
                  v-model="searchUnApply" @input="searchOnUnApply" outlined dense></v-text-field>
              </div>
              <v-list class="mt-2" flat subheader three-line>
                <v-list-item-group v-model="unApplySetting" multiple active-class="grey lighten-3"
                  style="max-height: 230px; overflow: auto">
                  <template v-for="(item, index) in searchedUnApply">
                    <v-list-item :key="index">
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox :input-value="active"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title v-text="item.name"
                            :class="!active ? 'text-secondary' : ''"></v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-card>
            <p class="mb-0 mt-2">
              {{ searchedUnApply.length }}/{{ unApplyRate.length }}
              {{ $t("ITEMS_SHOWING") }}
            </p>
          </v-col>
          <v-col sm="1" class="d-flex align-center justify-content-center">
            <div>
              <v-btn class="d-block" @click="leftToRight">
                <v-icon>navigate_next</v-icon>
              </v-btn>
              <v-btn class="d-block mt-3" @click="rightToLeft">
                <v-icon>chevron_left</v-icon>
              </v-btn>
              <v-btn class="d-block mt-3" @click="allLeftToRight">
                <v-icon>keyboard_double_arrow_right</v-icon>
              </v-btn>
              <v-btn class="d-block mt-3" @click="allRightToLeft">
                <v-icon>keyboard_double_arrow_left</v-icon>
              </v-btn>
              <v-btn class="d-block mt-3" @click="compare">
                <v-icon>compare_arrows</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col sm="3">
            <v-card style="min-height: 350px">
              <v-card-title class="fs-14">{{ $t("ASSIGN") }}</v-card-title>
              <div class="pl-2 pr-2">
                <v-text-field prepend-inner-icon="mdi-magnify" :placeholder="$t('NAME_SELLING_PACKAGE')"
                  v-model="searchApply" @input="searchOnApply" outlined dense></v-text-field>
              </div>
              <v-list class="mt-2" flat subheader three-line>
                <v-list-item-group v-model="applySetting" multiple active-class="grey lighten-3"
                  style="max-height: 230px; overflow: auto">
                  <template v-for="(item, index) in searchedApply">
                    <v-list-item>
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox :input-value="active"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title v-text="item.name"
                            :class="!active ? 'text-secondary' : ''"></v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-card>
            <p class="mb-0 mt-2">
              {{ searchedApply.length }}/{{ applyRate.length }}
              {{ $t("ITEMS_SHOWING") }}
            </p>
          </v-col>
        </v-row>
        <div class="btn-bottom">
          <v-btn depressed class="mr-5" @click="back">
            {{ $t("BACK") }}
          </v-btn>
          <v-btn color="primary" class="pr-10 pl-10" @click="confirmSave()" :disabled="disableSaveBtn">{{ $t("SAVE")
          }}</v-btn>
        </div>
      </div>
    </v-form>
  </div>
</template>

<style lang="scss" scoped>
.subtitle {
  text-transform: uppercase;
  font-size: 15px;
}

.code input {
  text-transform: uppercase;
}

.invalid-text {
  color: red;
  margin-top: -15px;
  position: absolute;
}

.item-cancel-policy {
  border: 1px dashed #cdcdcd;
  padding: 10px;

  p {
    margin-bottom: 0;
  }
}

.item-payment-policy {
  border: 1px dashed #cdcdcd;
  padding: 10px;

  p {
    margin-bottom: 0;
  }
}

.current-cancellation {
  background: linear-gradient(0deg, rgba(0, 62, 148, 0.1), rgba(0, 62, 148, 0.1)), #ffffff;
  padding: 0 10px;
  margin-bottom: 10px;
  border-radius: 5px;

  p {
    margin-bottom: 0;
  }
}
</style>
<script>
import store from "@/plugins/store";
import { categoryService } from "@/_services/SaleRoom/category.service.js";
import { salePackageService } from "@/_services/SaleRoom/sale-package.service.js";
import { _alert, _formatCurrency } from "@/_helpers/function.js";
import VueNumeric from "vue-numeric";
const toLower = (text) => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
  if (term) {
    return items.filter((item) => toLower(item.name).includes(toLower(term)));
  }

  return items;
};
export default {
  components: {
    VueNumeric,
  },
  created() {
    this.getAllRate();
  },
  data() {
    return {
      panel: [0, 1],
      disableSaveBtn: false,
      isLoading: false,
      editedItem: null,
      tab: null,
      sysLang: this.$i18n.locale,
      lang: "vi",
      isAddNew: true,
      isEmptyDefaultTitle: false,
      rateList: [],
      applyRate: [],
      unApplyRate: [],
      searchApply: null,
      searchedApply: [],
      searchedUnApply: [],
      applySetting: [],
      unApplySetting: [],
      languages: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.name) : [],
      codeLangs: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.languageCode) : []
    };
  },
  computed: {},
  watch: {
    tab(value) {
      this.lang = value ? "en" : "vi";
    },
    lang(value) {
      this.editorData = this.editedItem.i18ns.find((x) => x.lang == value).description;
    },
  },
  mounted() { },
  methods: {
    async initialize() {
      this.isLoading = true;
      let id = this.$route.params.id;
      if (id != 0) {
        this.isAddNew = false;
        await categoryService.getDetail(id).then((res) => {
          this.editedItem = res.data;
          if (this.editedItem.ratePlanIds.length > 0) {
            this.applyRate = this.rateList.filter((e) =>
              this.editedItem.ratePlanIds.includes(e.id)
            );
            this.UnApplyRate = this.rateList.filter(
              (e) => !this.editedItem.ratePlanIds.includes(e.id)
            );

            this.searchedApply = this.rateList.filter((e) =>
              this.editedItem.ratePlanIds.includes(e.id)
            );
            this.searchedUnApply = this.rateList.filter(
              (e) => !this.editedItem.ratePlanIds.includes(e.id)
            );
          } else {
            this.unApplyRate = [...this.rateList];
            this.clearSearch();
          }
        });
      } else {
        this.isAddNew = true;
        const langs = JSON.parse(localStorage.getItem('listLangs')).map(item => item.languageCode); 
        this.editedItem = {
          nameVi: null,
          descriptionVi: null,
          i18ns: [],
          id: null,
          ratePlanIds: [],
          rateCategoryCode: null,
          convertedNight: 100
        };
        langs.forEach(lang => {
          this.editedItem.i18ns.push(
            {
              description: "",
              lang: lang,
              name: "",
            }
          )
        });
        this.unApplyRate = [...this.rateList];
        this.clearSearch();
      }
      this.isLoading = false;
    },
    validateAndFocusTab() {
        if (!this.editedItem.nameVi) {
            this.tab = 0;
            return;
        }

        for (let i = 0; i < this.codeLangs.length; i++) {
            const langCode = this.codeLangs[i];
            const roomLang = this.editedItem.i18ns.find(x => x.lang === langCode);

            if (!roomLang || !roomLang.name) {
                this.tab = i + 1;
                return;
            }
        }
    },
    async confirmSave() {
      await this.validateAndFocusTab()
      await this.$nextTick();
      let form_validate = this.$refs.form.validate();

      if (!form_validate) {
        store.commit("alert/display", {
          message: this.$t("_VALIDATE.REQUIRED"),
          error: true,
          success: false,
        });
        this.$nextTick(() => {
            const el = document.querySelector(".v-messages.error--text");
            if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        });
        return false;
      }

      let updatedData = Object.assign({}, this.editedItem);
      updatedData.rateCategoryCode = updatedData.rateCategoryCode.toUpperCase();
      delete updatedData.chainCode;
      updatedData.ratePlanIds = this.applyRate
        .map((item) => item.id);
      if (!this.isAddNew) {
        categoryService.updateRateCategory(updatedData).then((res) => {
          _alert(res, this.$t(res.data));
        });
      } else {
        delete updatedData.id;
        categoryService.createRateCategory(updatedData).then((res) => {
          if (res.responseCode === 0) {
            _alert(res, this.$t(res.data), false);
            this.$router.push({
              name: "rateCategorys",
            });
          } else {
            _alert(res, this.$t(res.data), false);
          }
        });
      }
    },
    updateRoomTitle(value) {
      if (value.length > 0) {
        this.isEmptyDefaultTitle = false;
        for (let i = 0; i < this.editedItem.i18ns.length; i++) {
          this.editedItem.i18ns[i].name = value;
        }
      } else {
        this.isEmptyDefaultTitle = true;
      }
    },
    updateRoomDescription(value) {
      for (let i = 0; i < this.editedItem.i18ns.length; i++) {
        this.editedItem.i18ns[i].description = value;
      }
    },
    getAllRate() {
      this.$session.set("ojbListOfSalePackage", this.paging);
      let body = {};
      body.keyword = "";
      body.status = 1;
      body.limit = 99999999;
      body.offset = 0;
      body.orderBy = 'active';
      body.asc = false;
      salePackageService
        .getAllPlan(body)
        .then((res) => {
          this.rateList = res.data.map(e => Object.assign({}, {
            id: e.id,
            name: e.i18ns.find((x) => x.lang == this.defaultI18n).name,
          }));
          this.initialize()
        })
        .finally(() => (this.isLoading = false));
    },
    clearSearch() {
      this.searchApply = null;
      this.searchUnApply = null;
      this.searchOnApply();
      this.searchOnUnApply();
    },
    searchOnApply() {
      this.searchedApply = searchByName(this.applyRate, this.searchApply);
    },
    searchOnUnApply() {
      this.searchedUnApply = searchByName(this.unApplyRate, this.searchUnApply);
    },
    leftToRight() {
      if (this.unApplySetting.length > 0) {
        this.unApplySetting.forEach((e) => {
          this.applyRate.push(this.searchedUnApply[e]);
        });
        this.unApplyRate = this.rateList.filter(
          (e) => !this.applyRate.map((e) => e.id).includes(e.id)
        );
        this.applySetting = [];
        this.unApplySetting = [];
        this.clearSearch();
      }
    },

    rightToLeft() {
      if (this.applySetting.length > 0) {
        this.applySetting.forEach((e) => {
          this.unApplyRate.push(this.searchedApply[e]);
        });
        this.applyRate = this.rateList.filter(
          (e) => !this.unApplyRate.map((e) => e.id).includes(e.id)
        );
        this.applySetting = [];
        this.unApplySetting = [];
        this.clearSearch();
      }
    },
    allLeftToRight() {
      if (this.searchedUnApply.length > 0) {
        this.searchedUnApply.forEach((e) => {
          this.applyRate.push(e);
        });
        this.unApplyRate = this.rateList.filter(
          (e) => !this.applyRate.map((e) => e.id).includes(e.id)
        );
        this.searchedUnApply = [];
        this.applySetting = [];
        this.unApplySetting = [];
        this.clearSearch();
      }
    },
    allRightToLeft() {
      if (this.searchedApply.length > 0) {
        this.searchedApply.forEach((e) => {
          this.unApplyRate.push(e);
        });
        this.applyRate = this.rateList.filter(
          (e) => !this.unApplyRate.map((e) => e.id).includes(e.id)
        );
        this.searchedApply = [];
        this.applySetting = [];
        this.unApplySetting = [];
        this.clearSearch();
      }
    },
    compare() {
      const apply = Array.from(new Set(this.applyRate.map(JSON.stringify))).map(
        JSON.parse
      );
      const unApply = Array.from(new Set(this.unApplyRate.map(JSON.stringify))).map(
        JSON.parse
      );
      this.applyRate = [...unApply];
      this.unApplyRate = [...apply];
      this.applySetting = [];
      this.unApplySetting = [];
      this.clearSearch();
    },
    back() {
      this.$router.push({ name: "rateCategorys" });
    },
  },
};
</script>
